<template>
  <el-dialog
    :visible="visible"
    :width="isMobile ? '95%' : '50%'"
    append-to-body
    :close-on-click-modal="false"
    class="status-modal"
    title="Перенос отклика в другой день"
    @open="beforeOpen"
    @close="beforeClose"
  >
    <el-row class="response-move__header" :gutter="24">
      <el-col :span="2"> # </el-col>
      <el-col :span="8"> Погрузка </el-col>
      <el-col :span="9"> Откликов </el-col>
      <el-col :span="5"> Перенести? </el-col>
    </el-row>
    <el-row
      v-for="(item, index) in listLoadDays"
      :key="item.id"
      class="response-move__item"
      :gutter="24"
    >
      <el-col :span="2">
        {{ index + 1 }}
      </el-col>
      <el-col :span="8">
        {{ item.load_date }}
      </el-col>
      <el-col :span="9">
        {{ item.responses.length }}
      </el-col>
      <el-col :span="5">
        <el-button type="primary" size="mini" @click="responseMove(item.id)">
          Перенести
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ResponseMove',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loadDays: {
      type: Array,
      default: () => [],
    },
    response: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listLoadDays: [],
    }
  },
  methods: {
    ...mapActions({ moveResponseToNewDay: 'responses/moveResponseToNewDay' }),
    beforeOpen() {
      this.listLoadDays = this.loadDays.filter(
        day => day.id !== this.response.load_day_id,
      )
    },
    beforeClose() {
      this.$emit('close')
    },
    responseMove(id) {
      const data = {
        response_id: this.response.id,
        load_day_id: id,
      }

      this.moveResponseToNewDay(data).then(response => {
        if (response) {
          this.$emit('update')
          this.$emit('close')
          this.$message({
            type: 'success',
            message: 'Отклил успешно перенесен',
            duration: 4000,
          })
        } else {
          this.$message({
            type: 'error',
            message: 'Перенос не произошел. Что то пошло не так!',
            duration: 4000,
          })
        }
      })
    },
  },
}
</script>

<style lang="sass">
.response-move__header
  margin: 10px auto
  padding: 10px
.response-move__item
  display: flex
  align-items: center
  background-color: #ebeef5
  margin: 10px auto
  padding: 10px
</style>
